import { useUploadInspectionDataModalContext } from './Context/UploadInspectionDataModalContext';
import { StyledAlert } from './UploadInspectionDataModal.style';

export const UploadAlert = () => {
  const { alertState: errorState } = useUploadInspectionDataModalContext();
  return errorState ? (
    <StyledAlert
      description={errorState.alertDescription}
      message={errorState.alertTitle}
      type={errorState.alertType}
    />
  ) : null;
};
